$ = require 'jquery'
PopOver = require 'app/scripts/views/lib/pop-over'
StickerView = require 'app/scripts/views/stickers/sticker-view'
Util = require 'app/scripts/lib/util'
_ = require 'underscore'
{ track } = require '@trello/analytics'

module.exports = class StickerEditView extends StickerView

  initialize: ->
    @listenTo @model, 'stopEditing', @stopEditing
    @listenTo @model, 'startEditing', @editSticker
    @listenTo @model, 'disableEditing', @disableEditing
    @listenTo @model, 'enableEditing', @enableEditing

  events:
    'mouseenter': 'mouseenter'
    'mouseleave': 'mouseleave'
    'mousedown': 'editSticker'
    'mousedown .js-remove-sticker': 'removeSticker'
    'mousedown .js-rotate-sticker': 'startRotate'
    'mousedown .js-move-sticker': 'startMove'

  showEditControls: ->
    true

  disableEditing: ->
    @$el.addClass('editing-disabled')

  enableEditing: ->
    @$el.removeClass('editing-disabled')

  endCurrentEdit: ->
    $(document).off '.stickerrotate .stickermove .stickerautomove'
    @$el.removeClass('moving rotating')
    $('.quick-card-editor').removeClass('invalid dragging')

  stopEditing: (e) ->
    Util.stop(e)

    if @isEditing()
      @endCurrentEdit()
      @$el.removeClass('editing')
      $('.quick-card-editor').removeClass('quick-card-editor-editing-stickers')
      for sticker in @model.collection.models
        sticker.trigger('enableEditing')

  isEditing: ->
    @$el.is('.moving, .rotating, .editing')

  isEditingDisabled: ->
    @$el.is('.editing-disabled')

  isMovingOrRotating: ->
    @$el.is('.moving, .rotating')

  saveStickerAttrs: ({ position, rotation }) ->
    round = (percent) ->
      Math.round(percent * 100) / 100

    update =
      zIndex: @model.collection.nextZIndex(@model)

    if position
      $card = @$el.closest('.list-card')
      $stickers = $card.find('.js-card-stickers')
      stickerAreaWidth = $stickers.width()
      stickerAreaHeight = $stickers.height()

      update.left = round(parseFloat(@$el.css('left')) / stickerAreaWidth * 100)
      update.top = round(parseFloat(@$el.css('top')) / stickerAreaHeight * 100)

    if rotation
      matrix = Util.getElemTransformMatrix(@$el.find('.sticker-image'))
      update.rotate = round(Util.getMatrixDegrees(matrix) % 360)

    @model.update update

    return

  mouseenter: (e) ->
    if !(@isEditingDisabled() || @isEditing() || @isMovingOrRotating())
      @$el.addClass('hover')
    return

  mouseleave: (e) ->
    @$el.removeClass('hover')
    return

  editSticker: (e) ->
    if e? && e.which != 1 # Non-left-click
      return

    Util.stop(e)
    isDrag = false

    if e? && e.type == 'mousedown'
      # Hold on to the mouse position, in case they start dragging
      { pageX: origX, pageY: origY } = e

      clear = =>
        $(document).off '.stickerautomove'
        clearTimeout(autoClear)

      $(document).on 'mousemove.stickerautomove', (e) =>
        # If they drag the cursor more than 5 px, they're probably trying to
        # drag
        if (Math.pow(e.pageX - origX, 2) + Math.pow(e.pageY - origY, 2)) > 5 * 5
          isDrag = true
          clear()
          @startMove(e)

      # Okay, it's a click, not a drag
      $(document).on 'mouseup.stickerautomove', clear

      # Just in case something goes wrong, clear the handlers after a second
      autoClear = @setTimeout clear, 1000

    # NOTE: We clone the array, so it doesn't get changed out from under us
    # when the models save
    stickers = _.clone(@model.collection.models)
    for otherSticker in stickers when otherSticker != @model
      otherSticker.trigger('stopEditing')
      otherSticker.trigger('disableEditing')

    # Defer adding the class so the controls-popping-out animation works on the
    # first click (we have to have it be in the DOM in non-editing mode so we
    # can css-transition to editing mode)
    @defer =>
      PopOver.hide()
      @$el.addClass('editing')
      $('.quick-card-editor').addClass('quick-card-editor-editing-stickers')

    return

  startRotate: (e) ->
    if !@isEditing()
      return

    Util.preventDefault(e)

    stickerOrigin =
      x: @$el.offset().left + (@$el.width() / 2)
      y: @$el.offset().top + (@$el.height() / 2)

    mousePosOrigin =
      x: e.pageX
      y: e.pageY

    originDistanceFromCenter = Util.calcDistanceFromCenter(@$el, mousePosOrigin.x, mousePosOrigin.y)

    startRotate = 0
    matrix = Util.getElemTransformMatrix(@$el.find('.sticker-image'))
    if matrix?
      startRotate = Util.getMatrixDegrees(matrix)

    didMove = false

    $(document).on 'mousemove.stickerrotate', (e) =>
      if !didMove
        @$el
          .removeClass('hover')
          .addClass('rotating')

        $('.quick-card-editor').addClass('dragging')
        didMove = true

      mousePos =
        x: e.pageX
        y: e.pageY

      dist = Util.calcDistanceFromCenter(@$el, mousePos.x, mousePos.y) * 4
      distDiff = dist - (originDistanceFromCenter * 4)

      endX = mousePos.x - stickerOrigin.x
      endY = mousePos.y - stickerOrigin.y

      mouseInitialRotate = Util.getDegrees(mousePosOrigin.y - stickerOrigin.y, mousePosOrigin.x - stickerOrigin.x)
      endRotate = Util.getDegrees(endY, endX)
      deltaRotate = endRotate - mouseInitialRotate

      newRotate = startRotate + deltaRotate

      @$el.find('.sticker-image').css
        'transform': "rotate(#{newRotate}deg)"
        '-webkit-transform': "rotate(#{newRotate}deg)"

      return

    $(document).on 'mouseup.stickerrotate', =>
      if didMove
        @saveStickerAttrs(rotation: true)
        @endCurrentEdit()
      else
        $(document).off '.stickerrotate'

    false

  startMove: (e) ->
    if !@isEditing()
      return

    Util.stop(e)

    $card = @$el.closest('.list-card')
    $stickersArea = $card.find('.js-card-stickers')

    { left: parentLeft, top: parentTop } = $stickersArea.offset()
    stickerWidth = @$el.width()
    stickerHeight = @$el.height()
    parentWidth = $stickersArea.width()
    parentHeight = $stickersArea.height()

    bounds =
      left: -40
      right: parentWidth - 10
      top: -40
      bottom: parentHeight - 10

    if e?
      # They clicked on the move handle, so hold that offset
      offsetX = @$el.offset().left + @$el.width() / 2 - e.pageX
      offsetY = @$el.offset().top + @$el.height() / 2 - e.pageY
    else
      offsetX = 0
      offsetY = 0

    didMove = false

    $(document).on 'mousemove.stickermove', (e) =>
      if !didMove
        @$el
          .removeClass('hover')
          .addClass('moving')

        $('.quick-card-editor').addClass('dragging')

        didMove = true

      newLeft = e.pageX - parentLeft - stickerWidth / 2 + offsetX
      newTop = e.pageY - parentTop - stickerHeight / 2 + offsetY

      valid = true
      if newLeft > bounds.right
        newLeft = bounds.right
        valid = false

      if newLeft < bounds.left
        newLeft = bounds.left
        valid = false

      if newTop > bounds.bottom
        newTop = bounds.bottom
        valid = false

      if newTop < bounds.top
        newTop = bounds.top
        valid = false

      $('.quick-card-editor').toggleClass('invalid', !valid)

      @$el.css
        left: newLeft
        top: newTop

    $(document).on 'mouseup.stickermove', =>
      if didMove
        @saveStickerAttrs(position: true)
        @endCurrentEdit()
      else
        $(document).off '.stickermove'

    false

  removeSticker: (e) ->
    if @isEditing()
      remove = _.once =>
        track("Card", "Sticker", "Remove via Edit")

        @stopEditing()
        @model.destroy()
        @$el.remove()
        return

      @$el.one 'transitionEnd webkitTransitionEnd', remove

      @setTimeout remove, 100

      @$el.addClass('fade-out')

    return
